import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './row.css';

const Row = (props) => {

    const classes = useStyles(props);

    return (
        <div className={classes.root} style={props.style}>
            {props.children}
        </div>
    );
}

Row.propTypes = {
    align: PropTypes.oneOf(['left', 'center', 'right']),
    gap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Row;